var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.handleClose}},[_c('Icon',{attrs:{"icon":"close","height":40,"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }